import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import {ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {CampaignSetupAgentToolName} from '../../../campaignSetupAgent.enums';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {addCard} from 'common/src/modules/campaigns/store/campaignLogic/actions/addCard';
import {CampaignTreeType} from 'common/src/modules/campaigns/campaigns.types';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {MapNode} from 'common/src/modules/nodes/nodes.types';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import isCreativeTypeNode from 'common/src/components/CLCardsMap/utils/isCreativeTypeNode';
import {
  CreativeNodePlaceholderCreativeId,
  DTCreativeNode,
} from 'common/src/modules/decisionTree/decisionTree.types';

const duplicateCardToolSchema = z.object({
  cardId: z.number().describe('The ID of the card to duplicate'),
});

export default function duplicateCardTool(store: CLStore) {
  async function execute({
    input: {cardId},
  }: ToolExecuteParams<typeof duplicateCardToolSchema>): Promise<ToolResult> {
    const {campaignLogic} = store.getState().campaignPage;
    const {dispatch} = store;

    const card = store.getState().campaignPage.campaignLogic.nodes.campaign[cardId];

    if (!card) {
      return toolError(`Card with ID ${cardId} not found`);
    }

    const nextId = campaignLogic.nextNodeId;

    const duplicatedCard: MapNode = {
      ...card,
      id: nextId,
      outputs: card.outputs.map((output) => ({
        ...output,
        nodeId: NO_NODE_ID,
        node: null,
      })),
      inputs: [],
    };

    if (isCreativeTypeNode(card.type)) {
      const creativeNode = duplicatedCard as Omit<DTCreativeNode, 'landingPageSource'>;
      creativeNode.creativeId = CreativeNodePlaceholderCreativeId;
      creativeNode.creative = undefined;

      dispatch(addCard({newNode: creativeNode, campaignTreeType: CampaignTreeType.Campaign}));
    } else {
      dispatch(addCard({newNode: duplicatedCard, campaignTreeType: CampaignTreeType.Campaign}));
    }

    return toolResult(`Card with ID ${cardId} duplicated successfully. New card ID is ${nextId}.`);
  }

  return tool({
    name: CampaignSetupAgentToolName.DuplicateCard,
    displayName: 'Duplicating the card',
    description: 'Duplicates a SINGLE card. Use this tool to duplicate a single card data.',
    execute,
    inputSchema: duplicateCardToolSchema,
  });
}
